import React , {useState,useRef} from 'react';
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import icon from '../../../assets/images/icon/connect-wallet.svg'
import oxpIcon from '../../../assets/images/logo/oxp.svg'
import soloIcon from '../../../assets/images/logo/solo.png'
import axios from 'axios';

const PopularCollection = props => {
    const data = props.data;
    const [visible , setVisible] = useState(12);
    const [loading , setLoading] = useState(false);
    const [searching , setSearching] = useState(false);
    const [showQr , setShowQr] = useState(false);
    const [qrString , setQrString] = useState('');
    const [listenWs , setlistenWs] = useState(false);
    const [noNfs , setNoNfs] = useState(false);
    const [richlistDict, setrichlistDict] = useState({});
    const [richlistLoading, setrichlistLoading] = useState(false);
    const [urlXumm, setUrlXumm] = useState('');
    const ws = useRef(WebSocket);

    const { search } = useLocation();
    const match = search.match(/address=(.*)/);
    const match2 = search.match(/richlist=(.*)/);
    const richlistBool = match2?.[1];
    const type = match?.[1];

    let isMobile = window.innerWidth < 900;

    console.log(type)    


    const getXummPayload = async (requestContent) => {
        try {
          let url = "https://nft-viewer-api.vercel.app/" + 'xumm/getpayload' + "?payloadID=" + requestContent;
          let response = await axios.get(url);
          return { success: true, data: response.data };
        } catch (error) {
          return { success: false };
        }
    }
    
    const postXummPayload = async () => {
    try {
        let url = "https://nft-viewer-api.vercel.app/" + 'xumm/createpayload';
        let response = await axios.get(url);
        console.log('response', response)
        return { success: true, data: response.data };
    } catch (error) {
        console.log(error)
        return { success: false };
    }
    }

    const checkValidSignature = async (requestContent) => {
    try {
        let url = "https://nft-viewer-api.vercel.app/" + 'xumm/checksig' + "?hex=" + requestContent;
        let response = await axios.get(url);
        console.log("xumm response", response)
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false };
    }
    }
      
    const signIn = async () => {
        try {
            setQrString('');

            let responseXum = await postXummPayload();
            console.log(responseXum)
            if (responseXum.data?.refs.qr_matrix){
                setQrString(responseXum.data?.refs.qr_png);
                setShowQr(true);
                if (isMobile) {
                    //open in new tab
                    // window.open(responseXum.data?.next.always, '_blank');
                    setUrlXumm(responseXum.data?.next.always);
                }
                ws.current = new WebSocket(responseXum.data?.refs.websocket_status);
                setlistenWs(true);
            }
            }
        catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        ws.current.onmessage = async (e) => {
            if (!listenWs) return;
            let responseObj = JSON.parse(e.data.toString());
            if (responseObj.signed !== null) {
                console.log(responseObj)
                const payload = await getXummPayload(responseObj.payload_uuidv4);
                console.log(payload)
                if (payload.success) {
                    console.log('signed')
                    if (responseObj.signed === true) {
                        let isValid = await checkValidSignature(payload.data.response.hex);
                        console.log(isValid)
                        //stop listening
                        ws.current.close();
                        let address = isValid.data.xrpAddress;
                        window.location.href = "/?address=" + address;
                    }
                }
            }
        }
    }, [listenWs])

    const showMoreItems = () => {
        setVisible(props.visible);
    }
    console.log(props.data.length)

    useEffect(() => {
        if(props.data.length > 0){
            setLoading(false);
        }
    }, [props.data])

    useEffect(() => {
        if (type) {
            setLoading(true);
            setSearching(true);
        }
        else {
            setLoading(false);
            setSearching(false);
        }

        if (richlistBool) {
            setLoading(false);
            setSearching(true);
            setrichlistLoading(true);
            let url1 = "https://nft-viewer-api.vercel.app" + '/api/richlist-1';
            let url2 = "https://nft-viewer-api.vercel.app" + '/api/richlist-2';

            let richlist1 = axios.get(url1);
            let richlist2 = axios.get(url2);
            
            Promise.all([richlist1, richlist2]).then((values) => {
                let richlist1 = values[0].data.richList;
                let richlist2 = values[1].data.richList;
                // console.log(richlist1)
                // console.log(richlist2)
                let richlist = {};

                for (let i = 0; i < richlist1.length; i++) {
                    // console.log(richlist1[i])
                    if (richlist1[i][0] in richlist) {
                        richlist[richlist1[i][0]] += richlist1[i][1];
                    }
                    else {
                        richlist[richlist1[i][0]] = richlist1[i][1];
                    }
                }

                for (let i = 0; i < richlist2.length; i++) {
                    // console.log(richlist2[i])
                    if (richlist2[i][0] in richlist) {
                        richlist[richlist2[i][0]] += richlist2[i][1];
                    }
                    else {
                        richlist[richlist2[i][0]] = richlist2[i][1];
                    }
                }
                //sort richlist from highest to lowest
                let sortable = [];
                for (let address in richlist) {
                    sortable.push([address, richlist[address]]);
                }
                sortable.sort(function (a, b) {
                    return b[1] - a[1];
                });
                let richlistSorted = {};
                for (let i = 0; i < sortable.length; i++) {
                    richlistSorted[sortable[i][0]] = sortable[i][1];
                }
                setrichlistLoading(false);
                setrichlistDict(richlistSorted);
            }
            )
        }
    }, [type, richlistBool])
    
    useEffect(() => {
        if (props.visible === 0) {
            setLoading(false)
            console.log('No nfts')
            setNoNfs(true);
        }
    }, [props.visible])



  return (
    <section className="tf-section trendy-colection-page style-2">
                {loading ? 
                    <div className="col-md-12 text-center">
                        <div className="loader">
                        </div>
                    </div>
                : <></>}

                {noNfs ?
                    <div className="col-md-12 text-center">
                        <br/>
                        <h3 className="display-2">
                            No NFTs found for this address.<br/><br/>
                            <small className="text-muted">Consider buying some from <a href="https://sologenic.org/profile/astronaughties">Sologenic</a> or <a href="https://nft.onxrp.com/collection/astronaughties/">onXRP Marketplace!</a></small>
                        </h3>
                    </div>
                : <></>}

                {richlistBool ?
                    richlistLoading ?
                        <div className="col-md-10 text-center">
                            Loading Richlist......
                            <br/>
                            <br/>
                            <br/>
                            <div className="dot-loader">
                            </div>
                        </div>
                    :
                    <div className="col-md-12 text-center">
                        <h3 className="display-2">
                            AstroNaughties Richlist!<br/> {/*a good punchline here*/}
                            <small className="text-muted">Are you in the top 100?</small>
                        </h3>
                        <div className="row">
                            <div className="col-md-12">
                                { !isMobile ?
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Rank</th>
                                                <th scope="col">Address</th>
                                                <th scope="col">Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(richlistDict).map((key, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        {/* <td>{key}</td> */}
                                                        <td>
                                                        <a href={"/?address=" + key} target="_blank" rel="noreferrer">
                                                            {key}
                                                        </a>
                                                        </td>
                                                        <td>{richlistDict[key]}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Rank</th>
                                                <th scope="col">Address</th>
                                                <th scope="col">Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(richlistDict).map((key, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        {/* <td>{key}</td> */}
                                                        <td>
                                                        <a href={"/?address=" + key} target="_blank" rel="noreferrer">
                                                            {key.substring(0, 5) + '...' + key.substring(key.length - 5, key.length)}
                                                        </a>
                                                        </td>
                                                        <td>{richlistDict[key]}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                : <></>}

        <div className="container">
            <div className="row">
                
                {
                    !searching ?
                    <h3>
                        Welcome to the AstroNaughties NFT Viewer!<br/>
                        <small className="text-muted">Enter an address to view its nfts.</small><br/> <br/>
                        <div className="sc-button" onClick={() => {
                            setShowQr(true);
                            signIn();
                        }}>
                            <h5>
                            <img src={icon
                            } alt="icon"
                            style={{width: '25px', height: '25px'}}
                            /> &nbsp;
                            Connect xumm Wallet
                            </h5>
                        </div>
                    </h3>
                    : <></>
                }
                {
                    showQr ?
                    <div className="col-md-12 text-center">
                        <h3>
                        <br/>
                            Scan the QR code with your xumm app to link your wallet.
                            <br/>
                            {/* <a href={urlXumm} target="_blank" rel="noreferrer">Click here to open xumm app</a> */}
                        </h3>
                        <br/>
                        <div className="qr-box" style={{width: '240px', height: '240px', margin: 'auto', border: '5px solid black', padding: '10px', borderRadius: '10px', backgroundColor: 'blue', marginBottom: '100px'}}>
                            <img src={qrString
                            } alt="xumm-qr"
                            style={{width: '200px', height: '200px'}}
                            />
                            {isMobile ?
                                <h4><small><a href={urlXumm} target="_blank" rel="noreferrer">Click here to open xumm app</a></small></h4>
                            : <></>
                            }
                        </div>
                    </div>
                    : <></>
                        
                }

                {
                    data.slice(0,visible).map((item,index)=> (
                        <div key={index} className="fl-item col-xl-3 col-lg-4 col-md-6">
                            <div className="sc-product-item style-5">
                                <div className="product-img">
                                    {/* check if item.title has `3D` in it, if so use video tag, else use img tag */} 
                                    {item.title.includes('3D') ? <video src={item.img} /> : <img src={item.img} />}
                                    <a href={item.url} target="_blank"
                                        className="sc-button style letter"><span>View Nft</span></a>
                                    <label>
                                        {item.price}
                                    </label>
                                </div>
                                <div className="product-content">
                                    <h5 className="title"><a href={item.url} target="_blank">{item.title}</a> </h5>
                                    <div className="product-author flex">
                                        <div className="avatar">
                                            {item.pfp ? <img src={item.pfp} alt="Avatar" /> : <img src={
                                                item.market === 'sologenic' ? soloIcon : oxpIcon
                                            } alt="Avatar" />}
                                        </div>
                                        <div className="infor">
                                            <div className="author-name">{item.name}</div>
                                            <span>{item.market}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {
                    visible < data.length && 
                    <div className="col-md-12">
                        <button id="loadmore" className=" sc-button style letter style-2" onClick={showMoreItems}><span>Load More</span>
                        </button>
                     </div>
                }
                
            </div>
        </div>
    </section>
    
    );
};

export default PopularCollection;
